import { Checkbox } from "@nextui-org/react";
const mySubscriptionscolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "examName",
    label: "Exam",
  },
  {
    key: "subscriptionMode",
    label: "Subscription",
  },
  {
    key: "startDate",
    label: "Subscription Date",
  },
  {
    key: "endDate",
    label: "End Date",
  },
];

export { mySubscriptionscolumn };
